import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Hide,
  Show,
} from '@chakra-ui/react';
import StructuredTextParser from '@eternal/Components/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { useCallback, useEffect, useState } from 'react';

/**
 *
 */
const CollCardInfo4 = ({ card, index }) => {
  const [elementHeight, setElementHeight] = useState(null);
  const [elementScrollHeight, setElementScrollHeight] = useState(null);

  const [elementScrollTop, setElementScrollTop] = useState(null);

  const [showShadow, setShowShadow] = useState(elementScrollHeight > 250);
  useEffect(() => {
    // setTimeout(() => {
    if (document) {
      const element = document.getElementById(`coll_para${index}`);
      if (element) {
        setElementScrollHeight(element.scrollHeight);
        setElementHeight(element.clientHeight);

        setElementScrollTop(element.scrollTop);
        var diff = difference(
          elementScrollTop + elementScrollTop,
          elementScrollHeight
        );
        if (elementHeight && !elementScrollTop) {
          setShowShadow(elementScrollHeight > 250);
        }
      }
    }
    // }, 1000);
  }, [1000]);
  useEffect(() => {
    // setTimeout(() => {
    if (document) {
      const element = document.getElementById(`coll_para${index}`);
      if (element) {
        setElementScrollHeight(element.scrollHeight);
        setElementHeight(element.clientHeight);
        setElementScrollTop(element.scrollTop);
        if (elementHeight && !elementScrollTop) {
          setShowShadow(elementScrollHeight > 250);
        }
      }
    }
    // }, 1000);
  }, [elementHeight]);
  // useEffect(() => {
  //   const coll_para = document.getElementById(`coll_para_${index}`);
  //   setElement(document.getElementById(`coll_para_${index}`));
  // element.onscroll = () => {
  //   console.log(this.scrollTop + this.clientHeight, 'just like that ');
  // };
  const difference = useCallback((first, sec) => {
    // console.log(first, sec);
    return Math.abs(first - sec);
  }, []);
  const scrollHandler = useCallback(
    el => {
      el.preventDefault();
      setElementHeight(el.target.clientHeight);
      setElementScrollHeight(el.target.scrollHeight);
      var diff = difference(
        el.target.scrollTop + el.target.clientHeight,
        el.target.scrollHeight
      );
      // console.log(diff);
      setElementHeight(el.target.clientHeight);
      setElementScrollHeight(el.target.scrollHeight);
      setElementScrollTop(el.target.scrollTop);
      //
      if (diff < 5) {
        setShowShadow(false);
      } else {
        setShowShadow(true);
      }
    },
    [difference]
  );

  // console.log(coll_para, element);
  // }, []);

  return (
    <Box
      h={{ base: 'auto', lg: 397 }}
      w={{ base: '100%', lg: 295 }}
      flex={1}
      background="#F0F0F0"
      mr="6px"
      p={{ base: '0', md: '18px' }}
      my="10px"
    >
      <Show above="lg">
        <Box h="100%">
          <Heading
            as="h4"
            fontSize="20px"
            color="#8C6E4F"
            fontFamily="FedraSerifAStdBook"
            fontWeight="300"
            borderBottom="1px solid #8C6E4F"
            h="52px"
            overflow="hidden"
            pb="10px"
            lineHeight="24px"
            noOfLines={2}
            isTruncated={false}
          >
            {card.title}
          </Heading>
          <Box
            maxHeight={270}
            overflow="auto"
            _hover={{ overflowY: 'auto' }}
            id={`coll_para${index}`}
            onLoad={e => setElementHeight(e?.target?.scrollHeight)}
            onScroll={el => scrollHandler(el)}
            // background={
            //   !showShadow && elementHeight < 250
            //     ? ''
            //     : !showShadow && elementHeight > 250
            //     ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
            //     : showShadow && elementHeight > 250
            //     ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
            //     : ''
            // }
            // background={
            //   // showShadow && elementHeight > 250
            //   //   ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
            //   //   : !showShadow
            //   //   ? ''
            //   //   : !showShadow && !elementHeight > 250
            //   //   ? ''
            //   //   : showShadow && elementHeight > 250
            //   //   ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
            //   //   : ''
            // }
            // background={
            //   showShadow
            //     ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
            //     : ''
            // }
          >
            <StructuredTextParser
              fontFamily="FedraSansStd-book"
              str={render(card.description.value)}
              pb="20px"
              pt="15px"
              mt="0"
              sx={{
                p: {
                  marginBottom: '7px',
                  display: 'flex',
                  color: '#040404',
                },
                strong: {
                  color: '#040404',
                },
              }}
              // className="coll_para"
            />
          </Box>
          {/* <Box
            w="100%"
            background="linear-gradient(180deg, 106, 106, 106, 0.5) 29.51%, rgba(106, 106, 106, 0.99) 100%)"
            mt="-20px"
            h="40px"
          ></Box> */}
        </Box>
      </Show>
      <Hide above="lg">
        <Accordion
          w="100%"
          allowMultiple
          allowToggle
          textAlign="left"
          py="0rem"
        >
          <AccordionItem
            borderBottomWidth={0}
            borderTopWidth={0}
            textAlign="left"
          >
            <AccordionButton
              textAlign="left"
              alignItems="flex-start"
              justifyContent="flex-start"
              display="block"
              py="0"
              style={{ display: 'block !important' }}
            >
              <Heading
                as="h4"
                fontSize={{ base: '16px', lg: '20px' }}
                color="#8C6E4F"
                fontFamily="FedraSerifAStdBook"
                textAlign="left"
                fontWeight="300"
                border="none"
                borderTop="none"
                display="flex"
                justifyContent="space-between"
                p={{ base: '10px 0', md: '5px 0' }}
              >
                {card.title}
                <AccordionIcon color="#000000" />
              </Heading>
            </AccordionButton>
            <AccordionPanel pb={4} pt="0">
              <Box
                maxHeight={270}
                h={270}
                // overflowY={elementHeight > 250 ? 'auto' : 'hidden'}
                overflowY="auto"
                _hover={{ overflowY: 'auto' }}
                id={`coll_para${index}`}
                onLoad={e => setElementHeight(e?.target?.scrollHeight)}
                onScroll={el => scrollHandler(el)}
                backgroundPosition="bottom"
                // backgroundImage={
                //   showShadow
                //     ? 'linear-gradient(180deg, rgba(4, 4, 4, 0.00) 82.28%, rgba(106, 106, 106, 0.30) 102.85%)'
                //     : ''
                // }
                pos="relative"
              >
                <StructuredTextParser
                  h="250px"
                  pt="30px"
                  borderTop="1px solid #8C6E4F"
                  // maxHeight={200}
                  fontSize={{ base: '16px', lg: '20px' }}
                  fontFamily="FedraSansStd-book"
                  // _hover={{ overflowY: 'auto' }}
                  str={render(card.description.value)}
                  mb="20px"
                  sx={{
                    p: {
                      marginBottom: '7px',
                      display: 'flex',
                      color: '#040404',
                    },
                    strong: {
                      color: '#040404',
                    },
                  }}
                  mt="0"
                  // id={`coll_para_${index}`}
                />
              </Box>
              <Box w="100%" background="#F0F0F0" mt="-20px" h="40px"></Box>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Hide>
    </Box>
  );
};

export default CollCardInfo4;
